import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TextCustomFieldConfig, SharedModule, FormInputComponent, DataService } from '@vendure/admin-ui/core';

@Component({
    selector: 'vdr-available-month-dates-form',
    templateUrl: './available-month-dates-form.component.html',
    styleUrls: ['./available-month-dates-form.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class AvailableMonthDatesFormComponent implements FormInputComponent<TextCustomFieldConfig> {
    readonly: boolean;
    config: TextCustomFieldConfig;
    formControl: FormControl;

    defaultValues = {
        date: 'all',
        openingTime: '00:00',
        closingTime: '23:59',
    };

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        if (this.formControl.value) {
            this.defaultValues = JSON.parse(this.formControl.value);
        } else {
            this.formControl.setValue(JSON.stringify(this.defaultValues));
        }
    }

    onValueChange(event: Event, type: 'date' | 'openingTime' | 'closingTime') {
        const newValue = (event.target as HTMLInputElement).value;
        this.defaultValues[type] = newValue;
        this.formControl.setValue(JSON.stringify(this.defaultValues));
    }
}
